export default __webpack_public_path__ + "static/media/iconhox.3e2fe97b.png";